/*
 *
 * FormField
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 21-Dec-2024
 */

import React from 'react'
import PropTypes from 'prop-types'
import './FormField.scss'

const FormField = ({ hide = false, readOnly = false, readOnlyComponent = null, children = null }) =>
  hide ? <></> : readOnly ? readOnlyComponent : children

FormField.propTypes = {
  // hide === true will hide the component
  hide: PropTypes.bool,
  // readOnly === true will show readOnlyComponent
  readOnly: PropTypes.bool,
  // readOnlyComponent will be shown if readOnly === true
  readOnlyComponent: PropTypes.node,
  // children will be shown if hide === false and readOnly === false
  children: PropTypes.node
}

FormField.defaultProps = {
  hide: false,
  readOnly: false,
  readOnlyComponent: null,
  children: null
}

export default FormField
